import { LOGIN_URL } from '@my-backoffice/app/shared/constants/app.constants';

export const OFFICE_365_LOGIN_PATH = '/auth2-service-cloud/v1.0/security/azure/login';

export const OFFICE_365_TOKEN_PATH = '/auth2-service-cloud/v1.0/security/azure/token';

export const OFFICE_365_PERMISSION_PATH = '/auth2-service-cloud/v1.0/permission/module-resources/module-name';

export const OFFICE_365_PERMISSION_MODULE_NAME = 'life-science-service-cloud';

export const OFFICE_365_LOGIN_URL = LOGIN_URL;

/** In-app post-login path when no `redirect` query param is provided (routing redirects `/home` to studies list). */
export const OFFICE_365_DEFAULT_REDIRECT = '/home';

export const OFFICE_365_MICROSOFT_LOGOUT_BASE = 'https://login.microsoftonline.com/common/oauth2/logout?client_id=';
